import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const ListWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 2px 5px;
  ${Styles.BorderStyles}
`;

export const ListItem = styled.div`
  padding: 2px 0;
  white-space: nowrap;
  cursor: pointer;
  ${Styles.FontStyles}
`;